export default __webpack_public_path__ + "static/media/Amanita17.467fa191.jpg";